import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getCampaignLog = async (selectedDomain: string, filters: FilterProps[], page: number = 0, pageSize: number = 100): Promise<AppFetchResponse> => {
    const { from, to } = filters.find(filter => filter.filterKey === 'days')!;
    // const templatesFilter = filters.find(filter => filter.filterKey === 'templates')!;
    // const templateIds = templatesFilter.selected ? templatesFilter.options?.filter(option => templatesFilter.selected ? option?.key === templatesFilter.selected : option?.key).map(option => option?.key) : [];
    // const campaignsFilter = filters.find(filter => filter.filterKey === 'campaigns')!;
    // const campaignIds = campaignsFilter.selected ? campaignsFilter.options?.filter(option => campaignsFilter.selected ? option?.key === campaignsFilter.selected : option?.key).map(option => option?.key) : [];
    // const statusFilter = filters.find(filter => filter.filterKey === 'status')!;
    // const statuses = statusFilter.options?.filter(option => statusFilter.selected ? option?.key === statusFilter.selected : option?.key).map(option => option?.key);
    // const clientFilter = filters.find(filter => filter.filterKey === 'clientId')!;
    // const clientParam = clientFilter?.value ? `&clientId=${clientFilter.value}` : '';
    // const phoneFilter = filters.find(filter => filter.filterKey === 'phone')!;
    // const phoneParam = phoneFilter?.value ? `&phone=${phoneFilter.value}` : '';
    // const checkoutFilter = filters.find(filter => filter.filterKey === 'checkoutId')!;
    // const checkoutParam = checkoutFilter?.value ? `&checkoutId=${checkoutFilter.value}` : '';

    return appFetch({
        endpoint: `campaigns/campaign-log?domain=${selectedDomain}&page=${page}&pageSize=${pageSize}&from=${from}&to=${to}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}